<script>
    export let id = null;
    export let label = null;
	export let sublabel = null;
    export let value = null;
    export let maxlength = null;
    export let required = false;
    export let disabled = false;
    export let placeholder = null;
	export let validator = null;

	$: value = value ? value.toLowerCase() : value;

</script>

{#if label}
	<label for={id}>
		{label}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}

	</label>
{/if}
<input {id} class="form-control" type="email" {required} {disabled} {placeholder} {maxlength} data-validator={validator} bind:value={value} on:change />

